<template>
  <div class="stacking-bar">
    <div id="stackingBarMonthId" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {errorHandler} from '../../../../utils/errorHandler'
  import {api} from '../../../../view/api/ElectronicManagement'

  export default {
    name: 'electronic-month-stacking-bar',
    props: {
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '240px'
        }
      },
      buildingCode: {
        type: String,
        default () {
          return ''
        }
      }
    },
    data () {
      return {
        sceneList: [],
        sceneNameList: []
      }
    },
    mounted () {

    },
    methods: {
      // 获取场景列表
      getElectricSceneList () {
        this.$axios.post(api.getElectricSceneList, {})
          .then(res => {
            let list = res.data.data
            let sceneNameList = []
            list.map(v => {
              sceneNameList.push(v.name)
            })
            this.sceneList = list
            this.sceneNameList = sceneNameList
            this.getEelectricity()
          })
          .catch(errorHandler('获取场景列表失败'))
      },

      // 获取电量
      getEelectricity () {
        let buildingCode = ''
        if (this.buildingCode !== '0') {
          buildingCode = this.buildingCode
        }
        this.$axios.post(api.getEelectricity, {
          billType: '3',
          buildingCode: buildingCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let xData = []
              let barData = []
              this.sceneList.map((scene, sceneIndex) => {
                barData[sceneIndex] = {
                  sceneCode: scene.code,
                  sceneData: [],
                  sceneMoneyData: []
                }
              })
              data.map((v, i) => {
                xData.push(v.billTime)
                barData.map(barDataItem => {
                  barDataItem.sceneData[i] = 0
                  barDataItem.sceneMoneyData[i] = 0
                })
                if (v.details) {
                  v.details.map(detail => {
                    barData.map(barDataItem => {
                      if (barDataItem.sceneCode === detail.electricSceneCode) {
                        barDataItem.sceneData[i] = detail.electricSceneData
                        barDataItem.sceneMoneyData[i] = detail.electricSceneMoney
                      }
                    })
                  })
                }
              })
              this.drawContractListGroupByFellower(xData, barData)
            }
          })
          .catch(errorHandler('获取电量失败'))
      },
      drawContractListGroupByFellower(xData, barData) {
        let series = []
        let color1 = ['#003366', '#116CC7', '#3C8DDF', '#68A6E3', '#B2CEEA']
        let color2 = ['#68000A', '#AB1E2C', '#F3384A', '#F36D7A', '#F7909A']
        let legendData = []
        barData.map((barDataItem, barDataIndex) => {
          legendData[barDataIndex] = this.sceneNameList[barDataIndex]
          legendData[barDataIndex + this.sceneNameList.length] = `${this.sceneNameList[barDataIndex]}金额`
          series[barDataIndex] = {
            name: this.sceneNameList[barDataIndex],
            type: 'bar',
            stack: '总量',
            barGap: 0,
            // label: {
            //   normal: {
            //     show: true
            //   }
            // },
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: color1[barDataIndex],
              },
            },
            data: barDataItem.sceneData
          }
          if (this.sceneNameList.length > 0) {
            series[barDataIndex + this.sceneNameList.length] = {
              name: `${this.sceneNameList[barDataIndex]}金额`,
              type: 'bar',
              stack: '金额',
              barGap: 0,
              // label: {
              //   normal: {
              //     show: true
              //   }
              // },
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  color: color2[barDataIndex],
                },
              },
              data: barDataItem.sceneMoneyData
            }
          }
        })
        let contract_follow = this.$echarts.init(document.getElementById('stackingBarMonthId'))
        contract_follow.setOption({
          title: {
            text: '近一年电量统计',
          },
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: legendData
          },
          grid: {
            left: '30px',
            right: '50px',
            bottom: '0px',
            containLabel: true
          },
          xAxis:  {
            type: 'category',
            name: '日期',
            data: xData
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: false
              },
              name: '用电量(kW·h)'
            }, {
              type: 'value',
              splitLine: {
                show: false
              },
              name: '金额(元)'
            }
          ],
          series: series
        })
      },
    },
    watch: {
      buildingCode () {
        this.getElectricSceneList()
      }
    }
  }
</script>

<style scoped>
  .stacking-bar {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Bar/StackingBar/ElectronicMonthStackingBar.vue